import { log } from '../../services/utils';

import { noraApiRequest } from './';

const lookup = async ( id, description, signal ) => {
	log( `* lookup ${ description }` );
	const { data } = await noraApiRequest( {
		url: '/lookups',
		params: { typeId: id },
		signal
	} );

	return data;
};

export const getLookups = async signal => {
	log( '* get lookups' );

	const response = await noraApiRequest( {
		url: '/lookups',
		signal
	} );

	return response.data;
};

export const getAgencyTypes = signal => lookup( 1, 'agency types', signal );

export const getContactTypes = signal => lookup( 2, 'contact types', signal );

export const getCredentialTypes = signal => lookup( 3, 'credential types', signal );

export const getTagTypes = signal => lookup( 4, 'tag types', signal );

export const getProgramTypes = signal => lookup( 5, 'program types', signal );

export const getProgramStatuses = signal => lookup( 6, 'program statuses', signal );

export const getTemplateOccurrences = signal => lookup( 7, 'template occurrences', signal );

export const getTemplateStatuses = signal => lookup( 8, 'tempate statuses', signal );

export const getTemplateRequirements = signal => lookup( 9, 'template requirements', signal );

export const getTagAuthScopes = signal => lookup( 17, 'tag authorization scopes', signal );

export const getSnoozeDurations = signal => lookup( 19, 'snooze durations', signal );

export const getNotificationDigestTypes = signal => lookup( 24, 'notification digest types', signal );

export const getTemplateTypes = signal => lookup( 26, 'template types', signal );

export const getTemplateModules = async signal => {
	log( '* get template modules' );
	const response = await noraApiRequest( {
		url: '/programs/documents/modules/lookups',
		signal
	} );

	return response.data;
};

export const getUserRoles = async signal => {
	log( '* lookup user roles' );
	const { data } = await noraApiRequest( {
		url: '/users/roles/lookups',
		signal
	} );

	return data;
};

export const getManagementOrganizations = async signal => {
	log( '* lookup management organizations' );
	const { data } = await noraApiRequest( {
		url: '/management/lookups',
		signal
	} );

	return data;
};

export const getAgencyOrganizations = async signal => {
	log( '* lookup agency organizations' );
	const { data } = await noraApiRequest( {
		url: '/agencies/lookups',
		signal
	} );

	return data;
};

export const getVendorOrganizations = async signal => {
	log( '* lookup vendor organizations' );
	const { data } = await noraApiRequest( {
		url: '/vendors/lookups',
		signal
	} );

	return data;
};

export const getProgramCoordinationOptions = async ( programID, signal ) => {
	log( '* lookup program coordination options' );
	const { data } = await noraApiRequest( {
		url: `/programs/${ programID }/coordination/lookups`,
		signal
	} );

	return data;
};

export const getAgencyCoordinationOptions = async ( agencyID, signal ) => {
	log( '* lookup agency coordination options' );
	const { data } = await noraApiRequest( {
		url: `/agencies/${ agencyID }/coordination/lookups`,
		signal
	} );

	return data;
};

export const getNotificationTypes = async ( userRoleTypeId, signal ) => {
	log( '* lookup notification types' );
	const { data } = await noraApiRequest( {
		url: '/lookups/notificationtypes',
		params: { userRoleTypeId },
		signal
	} );

	return data;
};

export const getServices = async signal => {
	log( '* lookup services' );
	const response = await noraApiRequest( {
		url: '/domainlookups/services',
		signal
	} );

	return response.data;
};

export const getCounties = async signal => {
	log( '* lookup counties' );
	const response = await noraApiRequest( {
		url: '/domainlookups/counties',
		signal
	} );

	return response.data;
};
